// @flow
import * as React from 'react';
import Indication from "../../../ui/indication";

export default function UIMessage(onHide, onShow, messages, UI) {
  return (
    <div>
      {messages && messages.length ? (
        <div className="indication-modal-wrap">
          {!UI.modals.hideMessages ? (
            <div>
              <div className="hide-messages" onClick={onHide}>
                <span
                  className="close-message icon cancel-circled clickable-icon pull-right"
                  title="Hide messages"
                />
              </div>
              <Indication
                className="event-form-indication indication-modal-footer"
                messages={messages}
              />
            </div>
          ) : (
            <div className="show-messages" onClick={onShow}>
              Show messages
            </div>
          )}
        </div>
        ) : null}
    </div>
  );
}
